import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import template from './edit-tree-menu.hbs'
import RenameForm from './rename-form'
import i18n from 'scoreboard/components/i18n'
import appDisplay from 'scoreboard/components/app-display'
import NewForm from './new-form'
import Organization from 'scoreboard/organizations/organization'
import GenericOverviewInfo from 'scoreboard/components/overview-info/generic-overview-info'
import permissions from 'scoreboard/components/permissions'
import dialogStack from 'scoreboard/components/dialog-stack'
import OrgTemplateWizard from 'scoreboard/organizations/org-template-wizard'
import OrgMoveOrCopyDestinationForm from './org-move-or-copy-destination-form'
import sections from 'scoreboard/components/sections'
import config from 'scoreboard/components/config'
import conductor from 'scoreboard/components/conductor'
import requiresOrg from 'scoreboard/components/requires-org'
import RecalculateScoresForm from './recalculate-scores-form'
import { dialog as templateDialog } from 'scoreboard/organizations/edit-template-form'
import projects from 'scoreboard/projects/projects'
import dependencyConfirmationPrompt from 'scoreboard/components/edit/dependency-confirmation-prompt'
import PromoteConfirmation from 'scoreboard/organizations/promote-confirmation'
import user from 'scoreboard/components/user'
import Breadcrumbs from 'scoreboard/components/breadcrumbs'

// either display a dialog if none is currently displayed, or replace the
// current one
function dialog(viewOrPromise, viewCreator) {
	if (dialogStack.peek()) {
		appDisplay.replaceDialog(viewOrPromise, viewCreator)
	} else {
		appDisplay.dialog(viewOrPromise, viewCreator)
	}
}

var EditTreeMenu = Backbone.View.extend({

	// this.model is an Organization

	tagName: 'ul',

	className: 'tree-menu',

	events: {
		'click .new-org': 'create',
		'click .rename': 'rename',
		'click .edit-template': 'editTemplate',
		'click .move': 'move',
		'click .copy': 'copy',
		'click .use-as-template': 'template',
		'click .promote': 'promote',
		'click .recalculate': 'recalculate',
		'click .info': 'info',
		'click .delete': 'delete'
	},

	/**
	 * @param options.gardener the gardener for the main org selector
	 */
	initialize: function(options) {
		this.options = options || {}
	},

	render: function () {
		let renameLabel
		if (this.model.isCopy()) {
			renameLabel = this.model.isDatasetCopy()
				? 'template.editTemplate'
				: 'template.editTemplatedCopy'
		} else {
			renameLabel = 'common.rename'
		}
		this.$el.append(template({
			renameLabel,
			promoteLabel: i18n.get('admin.organization.promote', this.getRootOrgLabel()),
			orgId: this.model.get('id')
		}))
		this.secure()
		return this
	},

	secure: function() {
		//allow the built-in admin actions normally prevented on high to be able
		//to fix this via UI
		let preventedByReplication = config.replicationInputEnabled && !user.isBuiltInAdmin()

		if (!this.model.get('modify') || preventedByReplication) {
			this.$('.rename, .copy, .use-as-template, .move').remove()
		}
		if (!this.model.get('cascade') || preventedByReplication) {
			this.$('.new-org').remove()
		}
		if (!this.model.get('delete') || preventedByReplication) {
			this.$('.delete').remove()
		}

		let removeCopyAsTemplate = () => {
			this.$('.use-as-template').remove()
		}

		if (this.model.isCopy()) {
			// can't use a template-copy as a template
			removeCopyAsTemplate()
		}

		// if the current org is already a template-copy
		var templateId = this.model.get('templateId')
		if (templateId) {
			// can't use a template-copy as a template or move to new project
			this.$('.use-as-template, .move').remove()

			var templateRootId = this.model.get('templateRootId')
			if (templateRootId && templateRootId !== this.model.get('templateId')) {
				// can't delete the child of a tree copy
				// (but you can delete the root of the copy)
				this.$('.delete').remove()
			}
		}

		// if no permission to modify templates
		if (this.model.isTemplate() || preventedByReplication) {
			var rootTemplateRootId = this.model.get('rootTemplateRootId')

			if (rootTemplateRootId && rootTemplateRootId != this.model.id) {
				// can't use a child of a tree template as another template
				// (but you can use the root of the tree template, or use
				// a single-org template)
				removeCopyAsTemplate()
			}
		}

		// Can only create one set of copies for a dataset template
		if (this.model.isDatasetTemplate()) {
			removeCopyAsTemplate()
		} else {
			// Note that the '.rename' button might be called Edit Template for
			// some template copies (see renameLabel logic), but this button is
			// specifically just for the root of a dataset template
			this.$('.edit-template').remove()
		}

		// #32319 can't delete individual dataset template copies
		if (this.model.isDatasetCopy()) {
			this.$('.delete').remove()
		}

		let tree = this.options.gardener.tree
		let isReplicatedCascaded =  _.get(tree.selected(), 'replicatedCascaded', false)
		// #23456 only direct descendants of root may be promoted
		let isDirectDescendantOfRoot = tree.root.id === this.model.get('parentId') ? true : false
		if (_.isNil(this.model.get('parentId')) || !permissions.promote() || config.replicationInputEnabled
			|| isReplicatedCascaded || !isDirectDescendantOfRoot) {
			this.$('.promote').remove()
		}

		// must be server admin to recalculate scores for an organization
		if (!permissions.serverAdmin()) {
			this.$('.recalculate').remove()
		}

		// #20619 - when projects aren't enabled, there is only a single org root
		// and DND is the only option a user should see to move orgs inside the root.
		if (!projects.isVisible() || !permissions.modifyProjects()) {
			this.$('.move').remove()
		}
	},

	create: function(e) {
		e.stopPropagation() // don't close the org selector

		var org = new Organization({ parentId: this.model.id })
		var newForm = new NewForm({ model: org })
		dialog(newForm)
	},

	rename: function(e) {
		e.stopPropagation() // don't close the org selector

		if (this.model.get('templateId')) {
			this.editTemplate(e)
		} else {
			var title = i18n.get('common.rename', i18n.get('common.organization.organization'))
			var form = new RenameForm({ title: title, model: this.model })
			dialog(form)
		}
	},

	editTemplate: function(e) {
		e.stopPropagation() // don't close the org selector
		templateDialog(this.model.id, { dialogFn: dialog })
	},

	move: function() {
		var moveForm = new OrgMoveOrCopyDestinationForm({
			model: this.model,
			orgId: this.model.id,
			copyType: 'tree',
			tree: this.options.gardener.tree
		})
		dialog(moveForm)
		moveForm.on('done', () => this.trigger('orgMoved'))
	},

	copy: function() {
		var copyForm = new OrgMoveOrCopyDestinationForm({
			model: this.model,
			// #31399 start with parent selected (if possible) so "org and descendants"
			// option is initially available
			orgId: this.model.get('parentId') || this.model.id,
			copy: true
		})
		dialog(copyForm)
		copyForm.on('done', () => this.trigger('orgMoved'))
	},

	template: function(e) {
		e.stopPropagation() // don't close the org selector

		new OrgTemplateWizard().start({
			xhr: $.get('api/organizations/template-form-info'),
			model: this.model,
			// #31399 start with parent selected (if possible) so "org and descendants"
			// option is initially available
			orgId: this.model.get('parentId') || this.model.id,
			display: dialog,
			copy: true,
			tree: this.options.gardener.tree
		})
	},

	promote: function(e) {
		e.stopPropagation() // don't close the org selector

		appDisplay.dialog(new PromoteConfirmation({
			orgLabel: this.model.get('label'),
			rootOrgLabel: this.getRootOrgLabel(),
			onConfirm: function() {
				var gardener = this.options.gardener
				var treeOptions = gardener._treeOptions()
				var section = sections.default(conductor.section())
				// make sure we have the correct org icons highlighted if the
				// user starts in admin
				section = requiresOrg(section) ? section : sections.default()
				const params = $.param({section, projectId: projects.id})
				var url = `api/organizations/${this.model.id}/promote?${params}`
				var rawStream = gardener._stream({url, method: 'post'})
				treeOptions.stream = rawStream.pipe(gardener._iconTransform())
				treeOptions.editable = true
				gardener._renderTree(treeOptions)

				var deferred = new $.Deferred()

				rawStream.on('loading', function () {
					deferred.resolve()
				})
				return deferred
			}.bind(this)
		}))
	},

	recalculate: function(e) {
		e.stopPropagation() // don't close the org selector
		var form = new RecalculateScoresForm({ model: this.model })
		dialog(form)
	},

	info: function(e) {
		e.stopPropagation()
		const organization = new Organization({ id: this.model.id })
		let data = { templateInfo: true }
		appDisplay.dialog(organization.fetch({ data }),
			() => new OrgOverviewInfo({ model: organization,
				gardener: this.options.gardener }))
	},

	'delete': function(e) {
		e.stopPropagation() // don't close the org selector
		const url = `api/organizations/${this.model.id}/delete-dependencies`
		dependencyConfirmationPrompt(url, this.model, info => {
			var list = _.concat(info.copies || [], info.descendants || [])
			// #33456 escape the response from the server and the org name
			info.warning = _.escape(info.warning)
			const label = _.escape(this.model.get('label'))
			return {
				list,
				message: this._createDeleteMessage(label, list, info.warning),
				prompt: i18n.get('common.project.delete.prompt', label)
			}
		})
	},

	_createDeleteMessage: function (parentLabel, list, warning) {
		var message = warning
		if (!_.isEmpty(list)) {
			var makeListItem = function(html, idLabel) {
				return html + '<li>' + _.escape(idLabel.label) + '</li>'
			}
			message += '<ul>' +
						   _.reduce(list, makeListItem, '<li>' + parentLabel + '</li>') +
					   '</ul>'
		}
		return message
	},

	getRootOrgLabel: function () {
		let tree = this.options.gardener.tree
		let rootId = tree.root.id
		return tree.get(rootId).label
	}

})

const OrgOverviewInfo = GenericOverviewInfo.extend({

	events: {
		'click .info': 'showInfo'
	},

	showInfo: function(e) {
		_.invoke(this.infoTooltip, 'remove')
		let target = e.target
		let id = this.$(target).closest('[data-id]').data('id') || target.getAttribute('data-id')
		let gardener = this.options.gardener
		const treeNode = gardener ? gardener.tree.nodes[id] : null
		if (treeNode) {
			this.infoTooltip = Breadcrumbs.tooltip({
				id,
				target,
				gardener
			})
		} else {
			$.get(`api/organizations/${id}/ancestors`, objects => {
				this.infoTooltip = Breadcrumbs.tooltip({id, target, objects})
			})
		}
	},

	remove() {
		GenericOverviewInfo.prototype.remove.apply(this, arguments)
		_.invoke(this.infoTooltip, 'remove')
	}
})

_.extend(EditTreeMenu, { OrgOverviewInfo })
export default EditTreeMenu
export { OrgOverviewInfo }

EditTreeMenu.__filename__ = 'organizations/edit-tree-menu.js'
